export const MIMES_DA_BIBLIOTECA = [
  "image/jpeg",
  "image/jpg",
  "image/png",
  "video/mp4",
  "video/quicktime",
] as const;

const MIMES = new Set<string>(MIMES_DA_BIBLIOTECA);
const EXTENSOES = new Set([".jpg", ".jpeg", ".png", ".mp4", ".mov"]);

export const ACEITE_DA_BIBLIOTECA = "image/jpeg,image/png,video/mp4,video/quicktime";

function extensaoDe(nome: string): string {
  const ponto = nome.lastIndexOf(".");
  if (ponto < 0) return "";
  return nome.slice(ponto).toLowerCase();
}

export function ehArquivoDaBiblioteca(arquivo: File): boolean {
  const mime = arquivo.type.toLowerCase();
  if (mime && MIMES.has(mime)) return true;
  return EXTENSOES.has(extensaoDe(arquivo.name));
}

export function filtrarArquivosDaBiblioteca(
  arquivos: readonly File[],
): { readonly aceitos: File[]; readonly recusados: File[] } {
  const aceitos: File[] = [];
  const recusados: File[] = [];
  for (const arquivo of arquivos) {
    if (ehArquivoDaBiblioteca(arquivo)) aceitos.push(arquivo);
    else recusados.push(arquivo);
  }
  return { aceitos, recusados };
}

export function dragTemArquivos(tipos: readonly string[]): boolean {
  return tipos.includes("Files");
}
